if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    // CONST STOREFRONT_API_KEY
    TOKEN = window.STOCK_API_KEY;

    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.variantData = {};
      this.productData = {};
      this.alternativeProductsContainer = this.querySelector('.pdp__fast-delivery');
      this.HTMLElements = {
        nettlager: {
          qty: this.querySelector('[data-location="nettlager"] .qdn-inventory__location-qty'),
          delivery: this.querySelector(
            '[data-location="nettlager"] .qdn-inventory__location-delivery'
          )
        },
        bergen: {
          qty: this.querySelector('[data-location="bergen"] .qdn-inventory__location-qty'),
          delivery: this.querySelector('[data-location="bergen"] .qdn-inventory__location-delivery')
        }
      };
      this.bundle = this.dataset.bundle;
      if (this.bundle === 'true') {
        this.fetchBundleInventory();
      } else {
        this.fetchInventory();
      }

      // Bind local variant change handler for hero-only updates
      this.onLocalVariantChange = (e) => {
        // React only if event comes from our own container hero or card-horizontal
        const heroEl = this.closest('product-hero');
        const cardEl = this.closest('product-card-horizontal');
        const isFromHero = heroEl && e.target === heroEl;
        const isFromCard = cardEl && e.target === cardEl;
        if (!isFromHero && !isFromCard) return;

        const variant = e.detail?.variant;
        if (!variant || !variant.id) return;

        const incomingId = variant.id;
        const normalizedId = incomingId.toString().includes('/')
          ? incomingId.toString().split('/').at(-1)
          : incomingId.toString();

        if (this.variantId === normalizedId) return; // avoid redundant updates

        this.variantId = normalizedId;
        this.updateInventory();
      };
    }

    //Variant change event subscription
    connectedCallback() {
      // Listen for local hero variant changes (scoped via event target containment)
      document.addEventListener('variant:change', this.onLocalVariantChange);

      // Keep existing global subscription for contexts that rely on pubsub
      this.unsubscribeVariantChange = subscribeEvent(
        PUB_SUB_EVENTS.syncCurrentVariant,
        ({ data }) => {
          if (data.currentVariant?.id) {
            this.variantId = data.currentVariant.id.toString().split('/').at(-1);
            this.updateInventory();
          } else if (data.currentVariantId) {
            this.variantId = data.currentVariantId.toString().split('/').at(-1);
            this.updateInventory();
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      document.removeEventListener('variant:change', this.onLocalVariantChange);
    }
    //END Variant change event subscription

    //Fetching and processing inventory data from server
    fetchBundleInventory() {
      fetch('/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.TOKEN
        },
        body: JSON.stringify({
          query: `{
            product(id: "gid://shopify/Product/${this.productId}") {
              productType
              vendor
              deliveryTime: metafield(namespace: "my_fields", key: "delivery_time") {
                key
                value
              }
              madeToOrder: metafield(namespace: "my_fields", key: "made_to_order") {
                key
                value
              }
              variants(first: 250) {
                nodes {
                  id
                  currentlyNotInStock
                  deliveryTime: metafield(namespace: "my_fields", key: "delivery_time") {
                    key
                    value
                  }
                  madeToOrder: metafield(namespace: "my_fields", key: "made_to_order") {
                    key
                    value
                  }
                  components(first: 100) {
                    nodes {
                      productVariant {
                        quantityAvailable
                        storeAvailability(first: 10) {
                          nodes {
                            available
                            quantityAvailable
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }`
        })
      })
        .then((res) => res.json())
        .then((data) => {
          this.processBundleData(data.data.product);
          this.updateInventory();
        });
    }
    fetchInventory() {
      fetch('/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.TOKEN
        },
        body: JSON.stringify({
          query: `{
            product(id: "gid://shopify/Product/${this.productId}") {
              productType
              vendor
              deliveryTime: metafield(namespace: "my_fields", key: "delivery_time") {
                key
                value
              }
              madeToOrder: metafield(namespace: "my_fields", key: "made_to_order") {
                key
                value
              }
              variants(first: 250) {
                nodes {
                  id
                  title
                  quantityAvailable
                  currentlyNotInStock
                  deliveryTime: metafield(namespace: "my_fields", key: "delivery_time") {
                    key
                    value
                  }
                  madeToOrder: metafield(namespace: "my_fields", key: "made_to_order") {
                    key
                    value
                  }
                  storeAvailability(first: 10) {
                    nodes {
                      available
                      quantityAvailable
                    }
                  }
                }
              }
            }
          }`
        })
      })
        .then((res) => res.json())
        .then((data) => {
          this.processData(data.data.product);
          this.updateInventory();
        });
    }

    processBundleData(queryResult) {
      this.productData.type = queryResult.productType;
      this.productData.vendor = queryResult.vendor;
      this.productData.deliveryTime = queryResult.deliveryTime
        ? queryResult.deliveryTime.value
        : false;
      this.productData.madeToOrder = queryResult.madeToOrder
        ? queryResult.madeToOrder.value
        : false;

      queryResult.variants.nodes.forEach((variant) => {
        let bergenStock = -999;
        let nettlagerStock = -999;
        variant.components.nodes.forEach((component) => {
          const componentBergen = component.productVariant.storeAvailability.nodes[0]
            ? component.productVariant.storeAvailability.nodes[0].quantityAvailable
            : 0;
          const componentNettlager = component.productVariant.quantityAvailable;
          if (bergenStock > componentBergen || bergenStock === -999) {
            bergenStock = componentBergen;
          }
          if (nettlagerStock > componentNettlager || nettlagerStock === -999) {
            nettlagerStock = componentNettlager;
          }
        });
        this.productData.isTapwellChrome = this.productData.vendor && variant.title && this.productData.vendor.toLowerCase() === 'tapwell' && variant.title.toLowerCase().includes('bronze');
        this.variantData[variant.id.split('/').at(-1)] = {
          vendor: this.productData.vendor,
          variantTitle: variant.title,
          bergenStock: bergenStock,
          nettlagerStock: nettlagerStock,
          deliveryTime: this.productData.isTapwellChrome ? '5-6 uker' : variant.deliveryTime
            ? variant.deliveryTime.value
            : this.productData.deliveryTime,
          madeToOrder: variant.madeToOrder
            ? variant.madeToOrder.value
            : this.productData.madeToOrder,
          continueSelling: variant.currentlyNotInStock
        };
      });
    }
    processData(queryResult) {
      this.productData.type = queryResult.productType;
      this.productData.vendor = queryResult.vendor;
      this.productData.deliveryTime = queryResult.deliveryTime
        ? queryResult.deliveryTime.value
        : false;
      this.productData.madeToOrder = queryResult.madeToOrder
        ? queryResult.madeToOrder.value
        : false;
      queryResult.variants.nodes.forEach((variant) => {
        const bergenStock = variant.storeAvailability.nodes[0]
          ? variant.storeAvailability.nodes[0].quantityAvailable
          : 0;
        this.productData.isTapwellChrome = this.productData.vendor && variant.title && this.productData.vendor.toLowerCase() === 'tapwell' && variant.title.toLowerCase().includes('bronze');
        this.variantData[variant.id.split('/').at(-1)] = {
          vendor: this.productData.vendor,
          variantTitle: variant.title,
          bergenStock: bergenStock,
          nettlagerStock: variant.quantityAvailable - bergenStock,
          deliveryTime: this.productData.isTapwellChrome ? '5-6 uker' : variant.deliveryTime
            ? variant.deliveryTime.value
            : this.productData.deliveryTime,
          madeToOrder: variant.madeToOrder
            ? variant.madeToOrder.value
            : this.productData.madeToOrder,
          continueSelling: variant.currentlyNotInStock
        };
      });
    }
    //END Fetching and processing inventory data from server

    //Update inventory status when variant changes or initial load
    updateInventory() {
      const variant = this.variantData[this.variantId];
      if(this.productData.type.toLowerCase() === "montering"){
        this.querySelector('[data-location="bergen"]').style.display = 'none';
        this.querySelector('[data-location="nettlager"]').style.display = 'none';
        this.querySelector('[data-location="rorlegger"]').classList.remove('hidden');

        return;
      }
      if (variant.bergenStock > 0 && variant.nettlagerStock > 0) {
        //SET COLORS
        this.HTMLElements.bergen.qty.style.setProperty(
          '--color-status',
          variant.bergenStock > 10 ? '#54C63A' : '#F4AF29'
        );
        this.HTMLElements.nettlager.qty.style.setProperty(
          '--color-status',
          variant.nettlagerStock > 10 ? '#54C63A' : '#F4AF29'
        );
        //SET STOCKS
        this.setStockText(this.HTMLElements.bergen.qty, variant.bergenStock, 'Klikk & hent: ');
        this.setStockText(this.HTMLElements.nettlager.qty, variant.nettlagerStock, 'Lagervare: ');
        //SET DELIVERY
        this.setDeliveryText(
          this.HTMLElements.nettlager.delivery,
          '3-5 virkedager',
          'Forventet levering: '
        );
        this.setDeliveryText(this.HTMLElements.bergen.delivery, null, null);
      } else if (variant.bergenStock > 0) {
        //SET COLORS
        this.HTMLElements.bergen.qty.style.setProperty(
          '--color-status',
          variant.bergenStock > 10 ? '#54C63A' : '#F4AF29'
        );
        this.HTMLElements.nettlager.qty.style.setProperty(
          '--color-status',
          variant.bergenStock > 10 ? '#54C63A' : '#F4AF29'
        );
        //SET STOCKS
        this.setStockText(this.HTMLElements.bergen.qty, variant.bergenStock, 'Klikk & hent: ');
        this.setStockText(this.HTMLElements.nettlager.qty, variant.bergenStock, 'Lagervare: ');
        //SET DELIVERY
        this.setDeliveryText(
          this.HTMLElements.nettlager.delivery,
          '3-5 virkedager',
          'Forventet levering: '
        );
        this.setDeliveryText(this.HTMLElements.bergen.delivery, null, null);
      } else if (variant.nettlagerStock > 0) {
        //SET COLORS
        this.HTMLElements.bergen.qty.style.setProperty(
          '--color-status',
          variant.nettlagerStock > 10 ? '#94E321' : '#F4AF29'
        );
        this.HTMLElements.nettlager.qty.style.setProperty(
          '--color-status',
          variant.nettlagerStock > 10 ? '#54C63A' : '#F4AF29'
        );
        //SET STOCKS
        this.setStockText(this.HTMLElements.bergen.qty, null, 'Leveres til butikk');
        this.setStockText(this.HTMLElements.nettlager.qty, variant.nettlagerStock, 'Lagervare: ');
        //SET DELIVERY
        this.setDeliveryText(
          this.HTMLElements.nettlager.delivery,
          '3-5 virkedager',
          'Forventet levering: '
        );
        this.setDeliveryText(this.HTMLElements.bergen.delivery, '3-5 virkedager', 'Hent etter: ');
      } else if (variant.continueSelling === false) {
        this.HTMLElements.bergen.qty.style.setProperty('--color-status', '#B6B6B6');
        this.HTMLElements.nettlager.qty.style.setProperty('--color-status', '#B6B6B6');
        this.setStockText(this.HTMLElements.bergen.qty, null, 'Utsolgt');
        this.setStockText(this.HTMLElements.nettlager.qty, null, 'Utsolgt');
        this.setDeliveryText(this.HTMLElements.nettlager.delivery, null, null);
        this.setDeliveryText(this.HTMLElements.bergen.delivery, null, null);
      } else {
        if (variant.madeToOrder === 'true') {
          this.HTMLElements.bergen.qty.style.setProperty('--color-status', '#BBC6C8');
          this.HTMLElements.nettlager.qty.style.setProperty('--color-status', '#BBC6C8');
          this.setStockText(this.HTMLElements.bergen.qty, null, 'Lages på bestilling');
          this.setStockText(this.HTMLElements.nettlager.qty, null, 'Lages på bestilling');
          if (variant.deliveryTime) {
            this.setDeliveryText(
              this.HTMLElements.nettlager.delivery,
              variant.deliveryTime,
              'Forventet levering: '
            );
            this.setDeliveryText(
              this.HTMLElements.bergen.delivery,
              variant.deliveryTime,
              'Hent i butikk etter: '
            );
          } else {
            this.setDeliveryText(
              this.HTMLElements.nettlager.delivery,
              '18+ virkedager',
              'Forventet levering: '
            );
            this.setDeliveryText(
              this.HTMLElements.bergen.delivery,
              '18+ virkedager',
              'Hent i butikk etter: '
            );
          }
        } else {
          this.HTMLElements.bergen.qty.style.setProperty('--color-status', '#94E321');
          this.HTMLElements.nettlager.qty.style.setProperty('--color-status', '#94E321');
          this.setStockText(this.HTMLElements.bergen.qty, null, 'Bestillingsvare');
          this.setStockText(this.HTMLElements.nettlager.qty, null, 'Bestillingsvare');
          if (variant.deliveryTime) {
            this.setDeliveryText(
              this.HTMLElements.nettlager.delivery,
              variant.deliveryTime,
              'Forventet levering: '
            );
            this.setDeliveryText(
              this.HTMLElements.bergen.delivery,
              variant.deliveryTime,
              'Hent i butikk etter: '
            );
          } else {
            this.setDeliveryText(
              this.HTMLElements.nettlager.delivery,
              '10-14 virkedager',
              'Forventet levering: '
            );
            this.setDeliveryText(
              this.HTMLElements.bergen.delivery,
              '10-14 virkedager',
              'Hent i butikk etter: '
            );
          }
        }
      }
      if (variant.bergenStock <= 0 && variant.nettlagerStock <= 0) {
        this.alternativeProductsContainer.classList.remove('hidden');
      } else {
        this.alternativeProductsContainer.classList.add('hidden');
      }
    }

    setStockText(qtyElement, qty, base, qtyAppend = '') {
      if (qty >= 100) {
        base = base.concat(`<strong class="qdn-inventory__quantity">100+ stk${qtyAppend}</strong>`);
      } else if (qty >= 50) {
        base = base.concat(`<strong class="qdn-inventory__quantity">50+ stk${qtyAppend}</strong>`);
      } else if (qty >= 20) {
        base = base.concat(`<strong class="qdn-inventory__quantity">20+ stk${qtyAppend}</strong>`);
      } else if (qty >= 10) {
        base = base.concat(`<strong class="qdn-inventory__quantity">10+ stk${qtyAppend}</strong>`);
      } else if (qty > 0) {
        base = base.concat(
          `<strong class="qdn-inventory__quantity">Kun ${qty} stk${qtyAppend}</strong>`
        );
      }
      qtyElement.innerHTML = base;
    }
    setDeliveryText(deliveryElement, deliveryTime, base) {
      if (!deliveryTime && !base) {
        deliveryElement.innerHTML = '';

        return;
      }
      base = base.concat(`<strong class="qdn-inventory__delivery">${deliveryTime}</strong>`);
      deliveryElement.innerHTML = base;
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
